import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { useLanguage } from '../contexts/LanguageProvider';

const EmailPendingPage: React.FC = () => {
    const { currentUser, logout, resendVerification } = useAuth();
    const { t } = useLanguage();
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const maskedEmail = currentUser?.email
        ? currentUser.email.replace(/^(.{2}).*(@.*)$/, '$1***$2')
        : '';

    const handleResend = async () => {
        setLoading(true);
        await resendVerification();
        setLoading(false);
        setSent(true);
    };

    return (
        <div className="min-h-screen bg-brand-dark flex flex-col items-center justify-center px-4">
            <div className="mb-10">
                <img src="/logo.png" alt="beYourAMP" className="h-10 w-auto" />
            </div>

            <div className="w-full max-w-md bg-brand-surface rounded-2xl border border-gray-800 p-8 flex flex-col items-center text-center gap-6">
                <div className="h-16 w-16 rounded-full bg-brand-orange/10 border border-brand-orange/30 flex items-center justify-center">
                    <svg className="h-8 w-8 text-brand-orange" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                    </svg>
                </div>

                <div>
                    <h1 className="text-2xl font-black text-white mb-2">{t('EMAIL_VERIFY_TITLE')}</h1>
                    <p className="text-brand-muted text-sm">{t('EMAIL_VERIFY_CHECK')}</p>
                    {maskedEmail && (
                        <p className="text-brand-orange font-mono text-sm mt-2">{maskedEmail}</p>
                    )}
                </div>

                {sent ? (
                    <p className="text-green-400 text-sm font-medium">{t('EMAIL_VERIFY_RESENT')}</p>
                ) : (
                    <button
                        onClick={handleResend}
                        disabled={loading}
                        className="w-full py-3 rounded-xl bg-brand-orange text-white font-bold hover:bg-orange-600 transition-all disabled:opacity-50"
                    >
                        {loading ? '...' : t('EMAIL_VERIFY_RESEND')}
                    </button>
                )}

                <button
                    onClick={logout}
                    className="text-brand-muted text-sm hover:text-white transition-colors"
                >
                    {t('LOGOUT')}
                </button>
            </div>
        </div>
    );
};

export default EmailPendingPage;
